<template>
	<form @submit.prevent="updateSight()">
		<div class="row">
			<div class="col-sm-8">
				<div class="row">
					<div class="form-group col-sm-4 mb-5">
						<BaseMultiSelect
							@update:value="setCountry"
							:options="geo.countriesSelect"
							rules="required"
							name="Country"
							:defaultData="data?.country?.id"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>
					<div class="form-group col-sm-4 mb-5">
						<BaseMultiSelect
							@change:value="getCities"
							@update:value="setCity"
							:options="geo.citiesSelect"
							:defaultData="data?.city?.id"
							rules="required"
							name="City"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>
					<div class="form-group col-sm-4 mb-4">
						<BaseInput
							name="activity"
							label="Activity"
							type="text"
							v-model="data.activity"
							class="form-control form-control-lg dashInput"
							rules="required|min:3"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>
					<div class="form-group col-sm-12 mb-5">
						<label for="description" class="form-label small custom-dark-text"
							>Description</label
						>
						<textarea
							v-model="data.description"
							class="form-control form-control-lg"
							id="description"
						></textarea>
					</div>
					<div class="form-group col-sm-12 mb-5">
						<BaseEditor
							:defaultData="data.inclusion"
							@updateData="setInclusion"
							name="Inclusion"
						/>
					</div>
					<div class="form-group col-sm-12 mb-5">
						<BaseEditor
							:defaultData="data.exclusion"
							@updateData="setExclusion"
							name="Exclusion"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="duration"
							label="Duration"
							type="text"
							v-model="data.duration"
							class="form-control form-control-lg dashInput"
							rules="required|min:1|max:50"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="closeDay"
							label="Close Day"
							type="text"
							v-model="data.closeDay"
							class="form-control form-control-lg dashInput"
							rules="required|min:1|max:50"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="openCloseTime"
							label="Open Close Time"
							type="text"
							v-model="data.openCloseTime"
							class="form-control form-control-lg dashInput"
							rules="required|min:1|max:20"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>

					<div class="form-group col-sm-3 mb-5">
						<BaseMultiSelect
							@update:value="setTransport"
							:options="transports.selectOptions"
							:defaultData="data.transport"
							rules="required"
							name="Transports"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>

					<div class="form-group col-sm-3 mb-4">
						<BaseInput
							name="startTime"
							label="Start Time"
							type="time"
							v-model="data.startTime"
							class="form-control form-control-lg dashInput"
							rules="required|min:1|max:20"
							@valError="valError"
							@valSuccess="valSuccess"
						/>
					</div>
					<div class="form-group col-sm-4 mb-5">
						<label for="remark" class="form-label small text-dark"
							>Remark</label
						>
						<textarea
							v-model="data.remark"
							class="form-control form-control-lg"
							id="remark"
						></textarea>
					</div>
					<div class="form-group col-sm-4 mb-5">
						<label for="remarkOne" class="form-label small text-dark"
							>Remark One</label
						>
						<textarea
							v-model="data.remarkOne"
							class="form-control form-control-lg"
							id="remarkOne"
						></textarea>
					</div>
					<div class="form-group col-sm-4 mb-5">
						<label for="remarkTwo" class="form-label small text-dark"
							>Remark Two</label
						>
						<textarea
							v-model="data.remarkTwo"
							class="form-control form-control-lg"
							id="remarkTwo"
						></textarea>
					</div>
					<div v-if="data.images.length" class="col-sm-12">
						<div class="row mx-auto py-4">
							<div
								v-for="image in data.images"
								:key="image"
								class="col-sm-2 m-4 position-relative"
							>
								<img class="package-img" :src="image" />
								<span
									@click="removeImage(image)"
									class="position-absolute top-100 start-75 badge rounded-pill bg-danger cursor-pointer"
									><i class="bi bi-x"></i
								></span>
							</div>
						</div>
					</div>
					<div class="col-sm-12">
						<div class="form-check form-switch">
							<input
								class="form-check-input"
								v-model="image.enabled"
								type="checkbox"
								id="imageCheck"
							/>
							<label class="form-check-label text-dark" for="imageCheck"
								>Upload package image</label
							>
						</div>
					</div>

					<div v-if="image.enabled" class="col-sm-12">
						<BaseImageUpload urlParam="sights" @images-data="setImage" />
					</div>
					<div class="form-group col-sm-6 mt-2">
						<BaseButton
							class="btn btn-primary form-control form-control-lg"
							type="submit"
							label="Update"
							:disabled="formState.disable"
							:loading="formState.isLoading"
						/>
					</div>
				</div>
			</div>
			<div class="col-sm-4 px-4">
				<h4 class="text-dark fs-4">Global Trip Holidays</h4>
				<p class="text-dark">
					Editing sightseen will modify it's current data.
				</p>
			</div>
		</div>
	</form>
</template>
<script>
	import { reactive, watch, inject } from "vue";
	import API from "@/config/api";
	import toast from "@/config/toast";
	import Helper from "@/helpers/dataHelper";
	import formCheck from "@/helpers/formCheckHelper";
	import BaseInput from "./BaseInput.vue";
	import BaseFileInput from "./BaseFileInput.vue";
	import BaseButton from "./BaseButton.vue";
	import BaseMultiSelect from "./BaseMultiSelect.vue";
	import BaseEditor from "./BaseEditor.vue";
	import BaseImageUpload from "./BaseImageUpload.vue";

	export default {
		name: "SightEdit",
		components: {
			BaseInput,
			BaseFileInput,
			BaseButton,
			BaseMultiSelect,
			BaseEditor,
			BaseImageUpload,
		},
		setup: () => {
			const masterStore = inject("masterStore");

			const data = reactive({
				country: null,
				city: null,
				activity: null,
				description: null,
				inclusion: null,
				exclusion: null,
				duration: null,
				closeDay: null,
				openCloseTime: null,
				transport: null,
				startTime: null,
				remark: null,
				remarkOne: null,
				remarkTwo: null,
				images: [],
			});

			const geo = reactive({
				countries: {},
				countriesSelect: {},
				selectedCountry: {
					id: null,
					name: null,
				},
				cities: {},
				citiesSelect: {},
				states: {},
			});

			const transports = reactive({
				selectOptions: Helper.transports,
			});

			const formState = reactive({
				isLoading: false,
				disable: false,
			});

			

			const validation = reactive({
				invalid: [],
				valid: [],
				nullable: [
					"description",
					"inclusion",
					"exclusion",
					"duration",
					"closeDay",
					"openCloseTime",
					"transport",
					"startTime",
					"remark",
					"remarkOne",
					"remarkTwo",
					"images",
				],
			});

			const changeFormLoadingState = () =>
				(formState.isLoading = !formState.isLoading);

			const updateSight = async () => {
				changeFormLoadingState();
				formState.disable = true;

				if (validation.invalid.length) {
					toast.error("Incomplete form", true);
					changeFormLoadingState();
					return;
				}

				try {
					await API.privateRequest.patch(
						`sights/${masterStore.state.editId}`,
						data,
					);
					toast.success(
						{ message: "Sight updated!", position: "topRight" },
						true,
					);
					masterStore.methods.changeComponent("table");
					changeFormLoadingState();
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
					changeFormLoadingState();
				}
			};

			//? adding and removing form fields from valid and invalid state
			const setFormVal = (data) => {
				if (validation.invalid.length) {
					const newInvalid = validation.invalid.filter(
						(error) => error.field !== data.field,
					);
					validation.invalid = newInvalid;
				}
				if (validation.valid.length) {
					const newValid = validation.valid.filter(
						(item) => item.field !== data.field,
					);
					validation.valid = newValid;
				}
				return;
			};

			// ! Country Functions
			const getCountries = async () => {
				try {
					const response = await Helper.getCountries();
					const countries = response;
					if (masterStore.state.data) {
						geo.countries = [
							{
								name: masterStore.state.data.country.name,
								id: masterStore.state.data.country.id,
							},
							...countries,
						];
					} else geo.countries = countries;
					geo.countriesSelect = countries.map((country) => {
						return { label: country.name, value: country.id };
					});
					if (masterStore.state.data) {
						geo.countriesSelect = [
							{
								label: masterStore.state.data.country.name,
								value: masterStore.state.data.country.id,
							},
							...geo.countriesSelect,
						];
					}
				} catch (error) {
					console.log(error);
				}
			};
			getCountries();

			const setCountry = (id) => {
				if (!id) {
					data.country = { id: 0, name: null };
					return;
				}
				const country = geo.countries.filter((country) => country.id === id);
				data.country = { id: country[0].id, name: country[0].name };
				getCities(data.country.name, "country");
			};

			// ! City Functions

			const getCities = async (name, type = false) => {
				if (!name) return;
				let data = {};
				if (type && type === "country") data = { countryName: name };
				else if (name.length < 3) return;
				else data.name = name.name;
				try {
					const cities = await Helper.getCities(data);
					geo.cities = [
						{
							name: masterStore.state.data.city.name,
							id: masterStore.state.data.city.id,
							state_name: masterStore.state.data.city.state_name || null,
						},
						...cities,
					];

					geo.citiesSelect = cities.map((city) => {
						return {
							label: `${city.name} ( ${city.state_name} )`,
							value: city.id,
						};
					});
					if (masterStore.state.data) {
						geo.citiesSelect = [
							{
								label: masterStore.state.data.city.name,
								value: masterStore.state.data.city.id,
							},
							...geo.citiesSelect,
						];
					}
				} catch (error) {
					console.log(error);
				}
			};

			const setCity = (id) => {
				if (!id) {
					data.city = { id: 0, name: null, state_name: null };
					return;
				}
				const city = geo.cities.filter((city) => city.id === id);
				data.city = {
					id: city[0].id,
					name: city[0].name,
					state_name: city[0].state_name,
				};
			};

			const setTransport = async (transportType) => {
				data.transport = transportType;
			};

			const setExclusion = (payload) => {
				data.exclusion = payload;
			};
			const setInclusion = (payload) => {
				data.inclusion = payload;
			};

			if (masterStore.state.data) {
				let keys = Object.keys(data);
				keys.map((key) => {
					data[key] = masterStore.state.data[key] || data[key];
				});

				geo.countriesSelect = [
					{
						label: masterStore.state.data.country.name,
						value: masterStore.state.data.country.id,
					},
				];

				geo.citiesSelect = [
					{
						label: masterStore.state.data.city.name,
						value: masterStore.state.data.city.id,
					},
				];

				getCities(data.country.name, "country");
			}

			const image = reactive({
				enabled: false,
			});

			const setImage = (images) => {
				if (!images.length) return;
				data.images = [...data.images, ...images];
				formState.disable = false;
			};

			const removeImage = async (img) => {
				if (!img) return;
				try {
					let response = await API.privateRequest.delete(
						`files?file=${img.split("/")[img.split("/").length - 1]}`,
					);
					if (response.data.success) {
						data.images = data.images.filter((image) => image !== img);
					}
				} catch (err) {
					console.log("image remove error ->", err);
				}
			};

			// event handler for valError event
			const valError = (input) => {
				// setFormVal(input);
				// validation.invalid = [...validation.invalid, input];
				// let check = formCheck(validation, data);
				// if (check) formState.disable = false;
				// else formState.disable = true;
			};

			const valSuccess = (input) => {
				// setFormVal(input);
				// validation.valid = [...validation.valid, input];
				// let check = formCheck(validation, data);
				// if (check) formState.disable = false;
				// else formState.disable = true;
			};

			return {
				geo,
				setCountry,
				getCities,
				setCity,
				transports,
				data,
				image,
				validation,
				formState,
				updateSight,
				valError,
				valSuccess,
				setTransport,
				setExclusion,
				setInclusion,
				setImage,
				removeImage,
			};
		},
	};
</script>

<style scoped>
	.package-img {
		width: 100%;
	}
</style>
